import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, trackHeartbeat } from "../lib/analytics";

export default function AnalyticsTracker() {
    const { pathname } = useLocation();
    const hb = useRef(null);

    useEffect(() => {
        trackPageview(pathname);
    }, [pathname]);

    useEffect(() => {
        hb.current = setInterval(() => {
            if (document.visibilityState === "visible") trackHeartbeat();
        }, 20000);
        return () => clearInterval(hb.current);
    }, []);

    return null;
}
